import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {EvkOption} from "@evomatik/evk-common";
import {BehaviorSubject, combineLatest, forkJoin, Observable, of, Subject} from "rxjs";
import {CatalogosService} from "../../../../services/catalogos.service";
import {filter, map, startWith} from "rxjs/operators";

@Component({
    selector: 'lib-datos-programa',
    templateUrl: './datos-programa.component.html',
    styleUrls: ['./datos-programa.component.css']
})
export class DatosProgramaComponent implements OnInit {
    @Input()
    form: FormGroup;

    programaOptions: EvkOption[] = [];
    programaFilteredOptions$: Observable<EvkOption[]>;

    nombreProgramaOptions: EvkOption[] = [];
    nombreProgramaFilteredOptions$: Observable<EvkOption[]>;

    cuadrillaOptions: EvkOption[] = [];
    cuadrillaFilteredOptions$: Observable<EvkOption[]>;

    catalogosCargados: EventEmitter<boolean> = new EventEmitter();

    constructor(public catalogoService: CatalogosService) {
    }

    ngOnInit(): void {
        this.cargaCatalogos();
        this.eventHandlerEventInit();
    }

    cargaCatalogos() {
        const requests = [];
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('PROGRAMA-SOCIAL'));
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('PROGRAMA-SOC-NOMBRE'));
        requests.push(this.catalogoService.getCuadrillas());
        forkJoin(requests).subscribe((
            [res1, res2, res3]:
                [EvkOption[], EvkOption[], EvkOption[]]
        ) => {
            this.programaOptions = res1;
            this.nombreProgramaOptions = res2;
            this.cuadrillaOptions = res3;
            this.catalogosCargados.emit(true);
        });
    }


    eventHandlerEventInit() {
        this.catalogosCargados.subscribe((res) => {
            if (res) {
                this.programaFilteredOptions$ = this.filterOptions(this.form.controls.a4Programa, of(this.programaOptions));
                this.nombreProgramaFilteredOptions$ = this.filterOptions(this.form.controls.a4NombrePrograma, of(this.nombreProgramaOptions));
                this.cuadrillaFilteredOptions$ = this.filterOptions(this.form.controls.a4Cuadrilla, of(this.cuadrillaOptions));

            }
        });
    }

    filterOptions = (formControl: FormControl | AbstractControl, opciones$: Observable<EvkOption[]>, valueChanges?: Observable<any> | Subject<any> | BehaviorSubject<any>) => {
        const valueChanges$ = valueChanges ? valueChanges : formControl.valueChanges;
        return combineLatest(
            [
                valueChanges$.pipe(startWith('')),
                opciones$
            ]
        ).pipe(
            filter(([value, _]) => typeof value === 'string'
            ),
            map(([name, opciones]) => name ? this._filter(name, opciones) : opciones.slice())
        );

    }

    _filter(label: string, options: EvkOption[]): EvkOption[] {
        const filterValue = this.removeAccents(label.toLowerCase());
        return options.filter(
            option =>
                this.removeAccents(option.label.toLowerCase()).indexOf(filterValue) !== -1);
    }

    removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    displayFn = (option) => (option && option.label) ? option.label : '';
}
